export const regexString = (s) => {
  //eslint-disable-next-line
  const regex = new RegExp(/^[A-Za-z\d`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]{0,32}$/i);
  return regex.test(s.trim());
}
